"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.putDefaultIntegrationById = exports.postDefaultIntegrations = exports.getDefaultIntegrationByUrl = exports.getDefaultIntegrationById = exports.getDefaultIntegrations = void 0;
const internalHelpers_1 = require("../internalHelpers");
const shared_1 = require("../models/shared");
const getDefaultIntegrations = async (accessToken, accountUrl, fulfillerUrl, fulfillmentLocationUrl, buyerUrl, options, env = shared_1.Env.PRODUCTION) => {
    const client = (0, internalHelpers_1.getAxiosInstance)(options);
    let headers = {
        Authorization: `Bearer ${accessToken}`,
    };
    if (options === null || options === void 0 ? void 0 : options.bypassCache) {
        headers = Object.assign(Object.assign({}, headers), { 'x-cache-id': Math.random() });
    }
    const response = await client.get(`${(0, internalHelpers_1.getBaseUrl)(env, { baseUrl: options === null || options === void 0 ? void 0 : options.baseURL })}/v0/defaultIntegrations`, {
        headers: headers,
        params: {
            accountUrl,
            fulfillerUrl,
            fulfillmentLocationUrl,
            buyerUrl,
            offset: options === null || options === void 0 ? void 0 : options.offset,
            limit: options === null || options === void 0 ? void 0 : options.limit,
            includeArchived: options === null || options === void 0 ? void 0 : options.includeArchived
        }
    });
    return response === null || response === void 0 ? void 0 : response.data;
};
exports.getDefaultIntegrations = getDefaultIntegrations;
const getDefaultIntegrationById = async (accessToken, id, env = shared_1.Env.PRODUCTION, options) => {
    const client = (0, internalHelpers_1.getAxiosInstance)(options);
    const response = await client.get(`${(0, internalHelpers_1.getBaseUrl)(env, { baseUrl: options === null || options === void 0 ? void 0 : options.baseURL })}/v0/integrationConfigurations/${id}`, { headers: { Authorization: `Bearer ${accessToken}` } });
    return response === null || response === void 0 ? void 0 : response.data;
};
exports.getDefaultIntegrationById = getDefaultIntegrationById;
const getDefaultIntegrationByUrl = async (accessToken, url, options) => {
    const client = (0, internalHelpers_1.getAxiosInstance)(options);
    const response = await client.get(url, { headers: { Authorization: `Bearer ${accessToken}` } });
    return response === null || response === void 0 ? void 0 : response.data;
};
exports.getDefaultIntegrationByUrl = getDefaultIntegrationByUrl;
const postDefaultIntegrations = async (accessToken, req, env = shared_1.Env.PRODUCTION, options) => {
    const client = (0, internalHelpers_1.getAxiosInstance)(options);
    const response = await client.post(`${(0, internalHelpers_1.getBaseUrl)(env, { baseUrl: options === null || options === void 0 ? void 0 : options.baseURL })}/v0/defaultIntegrations`, req, { headers: { 'Authorization': `Bearer ${accessToken}` } });
    return response === null || response === void 0 ? void 0 : response.data;
};
exports.postDefaultIntegrations = postDefaultIntegrations;
const putDefaultIntegrationById = async (accessToken, id, defaultIc, env = shared_1.Env.PRODUCTION, options) => {
    const client = (0, internalHelpers_1.getAxiosInstance)(options);
    const response = await client.put(`${(0, internalHelpers_1.getBaseUrl)(env, { baseUrl: options === null || options === void 0 ? void 0 : options.baseURL })}/v0/defaultIntegrations/${id}`, defaultIc, { headers: { Authorization: `Bearer ${accessToken}` } });
    return response === null || response === void 0 ? void 0 : response.data;
};
exports.putDefaultIntegrationById = putDefaultIntegrationById;
